<template>
  <div class="detail-card" data-card-id="report">
    <div
      class="card-header"
      :class="{ 'slidein-header': mode === 'draggable' }"
    >
      <div class="header-left">
        <h5 class="card-title">Report</h5>
      </div>
      <div class="header-right">
        <button
          class="drag-toggle-btn"
          @click.prevent="$emit('toggleDraggable')"
          :title="mode === 'draggable' ? 'Dock to panel' : 'Make draggable'"
        >
          <font-awesome-icon
            :icon="mode === 'draggable' ? ['fas', 'times'] : ['fas', 'clone']"
          />
        </button>
      </div>
    </div>
    <div class="card-content">
      <div class="detail-item">
        <span class="detail-label">Created on:</span>
        <span class="detail-value">{{
          formatDateTime(image?.report?.created_at, "yyyy-MM-dd HH:mm")
        }}</span>
      </div>
      <div
        class="detail-item"
        v-if="image?.report?.created_at && submission?.created_at"
      >
        <span class="detail-label">Turnaround Time:</span>
        <span class="detail-value">{{
          formatTime(
            (new Date(image.report.created_at) -
              new Date(submission.created_at)) /
              1000
          )
        }}</span>
      </div>
      <div class="detail-item" v-if="image?.report?.reporter">
        <span class="detail-label">Created by:</span>
        <span class="detail-value">{{
          image.report.reporter.investigatorCode
        }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Status:</span>
        <span class="detail-value">{{ image?.report?.status }}</span>
      </div>
      <div v-if="hasReportConclusion" class="expandable-section">
        <a
          href="#"
          @click.prevent="reportOpen = !reportOpen"
          class="section-toggle"
        >
          <font-awesome-icon
            :icon="
              reportOpen ? ['fas', 'chevron-down'] : ['fas', 'chevron-right']
            "
            class="me-2"
          />
          <b>Details</b>
        </a>
        <div v-if="reportOpen" class="report-content">
          <textarea
            readonly
            :value="image.report.conclusion"
            rows="15"
            class="report-textarea"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { formatDateTime } from '@/helpers/project-management/formatters'

const props = defineProps({
  image: Object,
  submission: Object,
  mode: {
    type: String,
    default: "parked",
  },
});

defineEmits(["toggleDraggable"]);

const reportOpen = ref(false);

const hasReportConclusion = computed(() => {
  if (!props.image || !props.image.report || !props.image.report.conclusion) {
    return false;
  }
  const conclusion = props.image.report.conclusion;
  return typeof conclusion === "string" && conclusion.trim().length > 0;
});


const formatTime = (seconds) => {
  if (seconds < 1) {
    return `${Math.round(seconds * 1000)} ms`;
  } else if (seconds < 60) {
    return `${seconds.toFixed(0)} seconds`;
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    return `${minutes} minutes`;
  } else if (seconds < 3600 * 24) {
    const hours = Math.floor(seconds / 3600);
    return `${hours} hours`;
  } else {
    const days = Math.floor(seconds / (3600 * 24));
    const singleDaySeconds = seconds % (3600 * 24);
    const hours = Math.floor(singleDaySeconds / 3600);
    return `${days} days ${hours} hours`;
  }
};
</script>

<style scoped>
/* Report Content */
.report-content {
  margin-top: 0.5rem;
}

.report-textarea {
  width: 100%;
  background-color: var(--color-bg-primary);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border-secondary);
  border-radius: var(--border-radius-small);
  padding: 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  resize: none;
}
</style>
